import BaseModel from './BaseModel'

export default class UserInfoModel extends BaseModel {
  get schema () {
    return {
      id: undefined,
      nickname: undefined,
      meta: undefined
    }
  }

  prepareCreate () {
    this.baseClear()

    return this
  }

  prepareUpdate () {
    this.baseClear()

    return this
  }
}
